import { useMutation, useQueryClient } from '@tanstack/react-query';
import { profileUpadte } from 'api';
import { toastEmitter } from 'components/Toast';

export default function useProfileUpdate({
  handleSuccess = () => null,
  handleError = () => null,
} = {}) {
  const queryclient = useQueryClient();
  const Request = useMutation({
    mutationFn: profileUpadte,
    mutationKey: ['profileUpadte'],
    onSuccess: (data) => {
      const status = data?.status;
      const responseData = data?.data;
      if (status !== 200) {
        handleError();
        return toastEmitter('error', responseData?.error?.message);
      }
      handleSuccess();
      queryclient.invalidateQueries('userDetails');
      toastEmitter('success', responseData?.data?.message);
    },
  });
  return { ...Request };
}
